export enum StatoDettaglioQuestionario {
    non_attivata = 'NON_ATTIVATA',
    non_consegnata = 'NON_CONSEGNATA',
    non_visibile = 'NON_VISIBILE',
    consegnata = 'CONSEGNATA'
}